import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/api/client";

const ParticipantAuthContext = createContext(null);

export function ParticipantAuthProvider({ children }) {
  const [participant, setParticipant] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/participant/me");
      setParticipant(data);
    } catch {
      setParticipant(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (rut, email) => {
    const { data } = await api.post("/auth/participant/login", { rut, email });
    setParticipant(data.participant);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/participant/logout"); } catch { /* noop */ }
    setParticipant(null);
    // SEGURIDAD/PRIVACIDAD: forzamos una recarga completa del navegador (en
    // vez de una navegación SPA) para garantizar que NINGÚN dato en memoria
    // de la sesión anterior (diagnóstico, informe, respuestas) pueda seguir
    // presente si otra persona usa el mismo dispositivo/pestaña después.
    window.location.href = "/login";
  };

  return (
    <ParticipantAuthContext.Provider value={{ participant, loading, login, logout, refresh }}>
      {children}
    </ParticipantAuthContext.Provider>
  );
}

export function useParticipantAuth() {
  const ctx = useContext(ParticipantAuthContext);
  if (!ctx) throw new Error("useParticipantAuth debe usarse dentro de ParticipantAuthProvider");
  return ctx;
}
